import { takeLatest, put,all } from 'redux-saga/effects';
import { requestStatisticsExits, requestHatchStatisticsExits, requestHatchStatisticsExitsParams } from './api';
import { statisticsExitsSuccess } from './actions';

import {
    GET_EXITS,
    GET_HATCH_EXITS, GET_HATCH_EXITS_PARAM
} from './constants';

/**
 *
 * @param action
 * @returns {IterableIterator<PutEffect<{exits: *, type: string}>>}
 */
function* getExitsStatistics(action) {
    const estatistic = yield requestStatisticsExits(action.quizID, action.params);

    if (estatistic){
      yield put( statisticsExitsSuccess (estatistic) );
    }
}


/***********************************************************************************************************************
 *
 * @param action
 ********************************************************************************************************************/
function* getHatchExitsStatistics(action) {
    const estatistic = yield  requestHatchStatisticsExits(action.hatchID);

    if (estatistic){
        yield put( statisticsExitsSuccess (estatistic) );
    }
}

function* getExitsStatisticsParams(action) {
    const estatistic = yield  requestHatchStatisticsExitsParams(action.hatchID, action.params);

    if (estatistic){
        yield put( statisticsExitsSuccess (estatistic) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watcQuizQuestionsExites(){
    yield  takeLatest(GET_EXITS, getExitsStatistics);
}

/**
 *
 * @returns {Generator<SimpleEffect<"FORK", ForkEffectDescriptor<never>>, void, *>}
 */
function* watcHatchQuestionsExites(){
    yield  takeLatest(GET_HATCH_EXITS,  getHatchExitsStatistics);
}

function* watcHatchQuestionsExitesParams(){
    yield  takeLatest(GET_HATCH_EXITS_PARAM, getExitsStatisticsParams);
}

/**
 *
 * @returns {Generator<CombinatorEffect<"ALL", IterableIterator<ForkEffect>|Generator<SimpleEffect<"FORK", ForkEffectDescriptor<never>>, void, *>>, void, *>}
 */
function* watchExites() {
    yield all([
        watcQuizQuestionsExites(),
        watcHatchQuestionsExites(),
        watcHatchQuestionsExitesParams()
    ]);
}

  
export default watchExites;